import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=0045b1fc&"
import script from "./TableComponent.vue?vue&type=script&lang=js&"
export * from "./TableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\invoiceasy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0045b1fc')) {
      api.createRecord('0045b1fc', component.options)
    } else {
      api.reload('0045b1fc', component.options)
    }
    module.hot.accept("./TableComponent.vue?vue&type=template&id=0045b1fc&", function () {
      api.rerender('0045b1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/base-table/components/TableComponent.vue"
export default component.exports